// extracted by mini-css-extract-plugin
export default {"textBox":"editable-span_textBox__FqYYI","disabled":"editable-span_disabled__0M92d"};